<template>
    <div>
        <b-modal id="modal-Themes" size="lg" class="modal-form" :title="modal_title" @hidden="CLEAR_FORM()" centered hide-footer>
            <ValidationObserver ref="form">
                <validation-provider rules="required" v-slot="{ errors }">
                    <div class="form-group">
                        <label>Themes Name</label>
                        <input v-model="formdata.name" type="text" class="form-control" name="name">
                        <div class="invalid-input">{{ errors[0] }}</div>
                    </div>
                </validation-provider>

                <validation-provider rules="required" v-slot="{ errors }">
                    <div class="form-group">
                        <label>Themes Code</label>
                        <input v-model="formdata.code" type="text" class="form-control" name="name">
                        <div class="invalid-input">{{ errors[0] }}</div>
                    </div>
                </validation-provider>

                <validation-provider rules="required" v-slot="{ errors }" >
                    <div class="form-group">
                        <label>Theme Type</label>
                        <v-select label="label" :reduce="themes_type => themes_type.value" v-model="formdata.type" :options="themes_type"></v-select>
                        <div class="invalid-input">{{ errors[0] }}</div>
                    </div>
                </validation-provider>

                <b-row>
                    <b-col md="4">
                        <validation-provider rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Main Background Color</label>
                                <input v-model="formdata.main_bg" type="text" class="form-control" name="name">
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </b-col>
                    <b-col md="4">
                        <validation-provider rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Second Background Color</label>
                                <input v-model="formdata.second_bg" type="text" class="form-control" name="name">
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </b-col>
                    <b-col md="4">
                        <validation-provider rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Third Background Color</label>
                                <input v-model="formdata.third_bg" type="text" class="form-control" name="name">
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </b-col>
                    <b-col md="4">
                        <validation-provider rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Main Text Color</label>
                                <input v-model="formdata.main_tx" type="text" class="form-control" name="name">
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </b-col>
                    <b-col md="4">
                        <validation-provider rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Second Text Color</label>
                                <input v-model="formdata.second_tx" type="text" class="form-control" name="name">
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </b-col>
                    <b-col md="4">
                        <validation-provider rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Third Text Color</label>
                                <input v-model="formdata.third_tx" type="text" class="form-control" name="name">
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </b-col>
                </b-row>

                <validation-provider v-if="!formdata.photo" rules="required|mimes:image/jpeg,image/png,image/jpg" v-slot="{ errors, validate }">
                    <div class="form-group" v-if="!formdata.photo">
                        <div class="mb-1">
                            <label>Cover Theme</label>
                        </div>
                        <div class="btn-up d-flex align-items-center" v-on:click.prevent="$refs.inputImage.click()">
                            <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                        </div>
                        <input ref="inputImage" 
                                type="file"
                                class="custom-file-input d-none"
                                id="Thumbnail"
                                v-on:change="onImageUpload"
                                accept="image/jpeg,image/png,image/jpg" 
                                @input="validate" >
    
                        <div class="invalid-input mt-3">{{ errors[0] }}</div>
                    </div>
                </validation-provider>
                
                <div class="form-group" v-if="formdata.photo">   
                    <div class="mb-1">
                        <label>Cover Theme</label>
                    </div> 
                    <button v-on:click.prevent="removeImageUpload()" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Themes</button> 
                    <div class="input-group img-sh">
                        <img :src="formdata.photo" class="img-responsive img-prf">
                    </div>
                    <div class="invalid-input mt-3">{{ errors[0] }}</div>
                </div>

                <div class="d-flex">
                    <label class="pl-0 custom-switch switch-big">
                        <input v-model="formdata.is_show" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                        <span class="custom-switch-indicator"></span>
                    </label>
                    <label class="mt-3 ml-3">
                        <span class="custom-switch-description ml-0"><strong>Themes Is Active</strong></span>
                        <p class="desc">This function is used to display themes on event settings</p>
                    </label>
                </div>
        
                <div class="button-modal text-right">
                    <button v-on:click="validationForm(formdata.id)" type="button" class="btn btn-new" v-bind:class="loading ? 'btn-progress' : ''">
                        Save Data
                    </button>
                </div>
            </ValidationObserver>
        </b-modal>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import {ValidationProvider, ValidationObserver} from "vee-validate";
    import vSelect from 'vue-select'

    export default{
        data(){
            return{
                loading:false,
                modal_title : 'Add Themes',
                photo_file:'',
            }
        },
        props: ['del_themes'],
        components: {
            ValidationProvider,
            ValidationObserver,
            vSelect
        },
        computed: {
            ...mapState('ThemesControl', {
                formdata: state => state.formdata,
                themes_type: state => state.themes_type,
                errors: state => state.errors
            }),
        },
        watch:{
            'formdata':function(val){
                if(val.id){
                    this.modal_title = 'Edit Themes'
                }else if(!val.id){
                    this.modal_title = "Add Themes"
                }
            },
        },
        methods: {
            ...mapActions('ThemesControl', ['createThemes','updateThemes']),
            ...mapMutations('ThemesControl', ['CLEAR_FORM']),
            
            onImageUpload: function(event) {
                var input = event.target;

                if (input.files && input.files[0]) {

                    var reader = new FileReader();
                    var vm = this;
                    reader.onload = function(e) {
                        vm.formdata.photo = e.target.result;
                    }
                    reader.readAsDataURL(input.files[0]);
                }
                this.photo_file = input.files[0]
            },
            removeImageUpload:function(){
                this.photo_file = ''
                this.formdata.photo = ''
            },
            validationForm: function(id) {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true

                        var formData = new FormData();
                        formData.append('name', this.formdata.name);
                        formData.append('type', this.formdata.type);
                        formData.append('code', this.formdata.code);
                        formData.append('main_bg', this.formdata.main_bg);
                        formData.append('second_bg', this.formdata.second_bg);
                        formData.append('third_bg', this.formdata.third_bg);
                        formData.append('main_tx', this.formdata.main_tx);
                        formData.append('second_tx', this.formdata.second_tx);
                        formData.append('third_tx', this.formdata.third_tx);
                        formData.append('is_show', this.formdata.is_show);
                        formData.append('photo', this.formdata.photo);
                        formData.append('photo_file', this.photo_file);
                        
                        if(id){
                            formData.append("_method", "put");
                            this.updateThemes(formData).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Themes')
                                this.$emit('getThemes');
                                this.CLEAR_FORM()
                                this.$toast.success('Successfully Update Themes')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            }) 

                        }else{

                            this.createThemes(formData).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Themes')
                                this.$emit('getThemes');
                                this.CLEAR_FORM()
                                this.$toast.success('Successfully Added Themes')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            }) 
                        }
                    }
                });
            },
        }
    }
</script>
